import { render, staticRenderFns } from "./assist_person.vue?vue&type=template&id=151edc5c&scoped=true"
import script from "./assist_person.vue?vue&type=script&lang=js"
export * from "./assist_person.vue?vue&type=script&lang=js"
import style0 from "./assist_person.vue?vue&type=style&index=0&id=151edc5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151edc5c",
  null
  
)

export default component.exports